import { Component, Inject, OnInit, EventEmitter, Output, Input, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HomeController } from '@shared/src/controllers/home/home.controller';
import { OpenRouteCMRController } from '@shared/src/controllers/open/openroutecmr.controller';
import { RouteCMRAgents } from '@shared/src/controllers/route/cmr/RouteCMRAgents';
import { RouteCMRAgentDto } from '@shared/src/dtos/route/cmr/agent/RouteCMRAgentDto';
import { HString } from '@shared/src/public-api';
import { Location } from '@angular/common';
import { SharedExternalCMRAgentListCMRsComponent } from '../../listcmrs/shared.external.cmr.agent.listcmrs.component';

@Component({
    selector: 'shared-external-cmr-agent-police-qr-component',
    templateUrl: './shared.external.cmr.agent.police.qr.component.html',
    styleUrls: ['../shared.external.cmr.agent.qr.page.scss']
})
export class SharedExternalCMRAgentPoliceQRComponent implements OnInit {


    public allLoaded: boolean = false;
    public useIonic: boolean = false;
    constructor(public router: Router, protected activatedRoute: ActivatedRoute,
        public location: Location,
        @Inject('HomeController') protected homeController: HomeController,
        public openRouteCMRController: OpenRouteCMRController) {

        if (homeController.useIonic)
            this.useIonic = homeController.useIonic();

    }

    ngOnInit(): void {
    

    }

    public __uuidQR: string;
    @Input()
    public set uuidQR(value: string) {
        if (this.__uuidQR === value)
            return;
        this.__uuidQR = value;
        this.loadData();
    }
    public get uuidQR(): string {
        return this.__uuidQR;
    }

    @Output() optionExpandedChanged = new EventEmitter<string>();

    public value: RouteCMRAgentDto;
    loadData() {
        if (!HString.isNullOrNullString(this.uuidQR)) {
            this.openRouteCMRController.getRouteCMRAgentByUUID(this.uuidQR, RouteCMRAgents.police).subscribe(data => { 
                this.value = data;
            });
        }
    }

    public getCount():number{
        if(this.value == null)
            return 0;
        return this.value.countRouteParts;
    }
    
    public __optionExpanded: string = "";
    @Input()
    public set optionExpanded(value: string) {
        if (this.__optionExpanded === value)
            return;
        this.__optionExpanded = value;
        this.optionExpandedChanged.next(this.__optionExpanded);
    }
    public get optionExpanded(): string {
        return this.__optionExpanded;
    }

    onClickLinkOption(option: string) {

        if (option == this.optionExpanded) {
            //Estem tancat l'opció oberta
            this.optionExpanded = "";
            return;
        }
        
        this.optionExpanded = option;
    }

    public getResourceGoods(): string{
        if(this.value == null || this.value.countRouteParts == 0)
            return "";
        if(this.value.countRouteParts == 1)
            return 'SHARED.EXTERNAL.CMR.SHOWGOOD.CAPTION';
        return 'SHARED.EXTERNAL.CMR.SHOWGOODS.CAPTION';
    }
    
    public getResourceControlDocument(): string{
        if(this.value == null || this.value.countRouteParts == 0)
            return "";
        if(this.value.countRouteParts == 1)
            return 'SHARED.EXTERNAL.CMR.SHOWCONTROLDOCUMENT.CAPTION';
        return 'SHARED.EXTERNAL.CMR.SHOWCONTROLDOCUMENTS.CAPTION';
    }

    @ViewChild(SharedExternalCMRAgentListCMRsComponent) listECMRsComponent: SharedExternalCMRAgentListCMRsComponent;
    
    public collapse(): boolean {
        if (this.optionExpanded) {
            
            if(this.optionExpanded == 'ControlDocument' && this.listECMRsComponent.collapse())
                return true;

            this.optionExpanded = "";
            return true;
        }
        return false;
    }

    public pretty(value: any): string {
        return JSON.stringify(value);
    }

}
